export const styles = theme => ({
  container: {
    padding: theme.spacing(0),
    '@media (min-width: 960px)': {
      maxWidth: 1200,
      padding: theme.spacing(0, 3)
    }
  },
  // Reserve space at the bottom of the page for the fixed mobile action bar
  // (with its "Not booked yet" line on Book & pay, which never hides).
  bookingShell: {
    paddingBottom: 132,
    '@media (min-width: 720px)': {
      paddingBottom: 0
    }
  }
})
